// custom typefaces
import "./src/styles/global.css"
import "typeface-montserrat"
import "typeface-merriweather"

import "prismjs/themes/prism.css"

/*
const darkModeScript = () => {
  window.onload = () => {
    setTimeout(() => {
      const btn = document.querySelector(".switch input");
      const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
      const currentTheme = localStorage.getItem("theme");
      if (currentTheme === "dark" || (currentTheme === null && prefersDarkScheme.matches)) {
        document.body.classList.toggle("dark-theme");
        btn.checked = true;
      } else if (currentTheme === "light" || (currentTheme === null && !prefersDarkScheme.matches)) {
        document.body.classList.toggle("light-theme");
        btn.checked = false;
      }
      btn.addEventListener("click", function () {
        document.body.classList.toggle("light-theme");
        document.body.classList.toggle("dark-theme");
        localStorage.setItem("theme",
          document.body.classList.contains("dark-theme")
            ? "dark"
            : "light");
      });
    }, 100);
  }
}

export const onClientEntry = () => {
  darkModeScript();
}
}*/
